export default __webpack_public_path__ + "static/media/fad-scissors.7b2496a8.svg";